var reTranslatorContext = /<for-translators-use>.*<\/for-translators-use>\s*/i;
export var sanitize = function sanitize(message) {
  return message.replace(reTranslatorContext, '');
};